import { useState } from "react";
import {  useSelector } from "react-redux";
import TableHead from './table-head'
import TableBody from './table-body'
import TableHeadMob from './table-head-mob'
import TableBodyMob from './table-body-mob'
import useSortableData from '../../hooks/sorting'
import useStickyHeader from "../../hooks/useStickyHeader";

const Table = ({data, columns, sortmobile, bookingPage, eventTypeId, reality, realty}) => {
    const { items, requestSort, sortConfig } = useSortableData(data);
    const mobile = useSelector(state => state.mobile);
    const [selectedOption, setSelectedOption] = useState(sortmobile[0]);    
    const { tableRef, isSticky } = useStickyHeader(true);

    const getClassName = name => {
        if (sortConfig && sortConfig.key && sortConfig.direction) {
          if (sortConfig.key === name) {
            return 'sort ' + sortConfig.direction;
          }
          return 'sort';
        }
        return 'sort';
    };

    if (mobile) {
        return (
            <div className="table-block">
                {/*isSticky && (
                    <div className="table sticky">
                        <TableHeadMob 
                            columns={columns} 
                            sortmobile={sortmobile} 
                            selectedOption={selectedOption}
                            setSelectedOption={requestSort}
                            sort={sortConfig}                        
                        />
                    </div>
                )*/}
                <div className="table" ref={tableRef}>
                    <TableHeadMob 
                        columns={columns} 
                        sortmobile={sortmobile} 
                        selectedOption={selectedOption}
                        setSelectedOption={requestSort}
                        sort={sortConfig}                        
                    />
                    <TableBodyMob reality={reality} bookingPage={bookingPage} columns={columns} data={items} eventTypeId={eventTypeId} realty={realty} />
                </div>
            </div>
        )
    }

    return (
        <div className="table-block">
            {/*isSticky && (
                <table className="table sticky">
                    <TableHead 
                        columns={columns} 
                        requestSort={requestSort}
                        getClassName={getClassName}
                    />
                </table>
            )*/}
            <table className="table" ref={tableRef}>
                <TableHead 
                    columns={columns} 
                    requestSort={requestSort}
                    getClassName={getClassName}
                />
                <TableBody reality={reality} columns={columns} data={items} eventTypeId={eventTypeId} realty={realty} />
            </table>    
        </div>    
    )

}

export default Table